import { PropertyanalyticsState } from "./types";

export const defaultState = (): PropertyanalyticsState => {
  return {
    editing: null,
    makingApiRequest: false,
    lastUpdate: new Date(),
    propertyanalytics: [],
    links: {}
  };
};

export const state = defaultState();
